import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import DateRangeModel from 'common/components/DatePickerModel/DateRangeModel';
import { ACTIVITY_TYPE } from 'common/constants';
import { RootState } from 'common/store/AppStore';
import {
	setHorizonFilter,
	setHorizonSelectedAppliedFilterList,
} from 'common/store/reducer/horizonScanReducer';
import {
	convertDateforApi,
	filterDataHandler,
} from 'common/utils/utilFunctions';

import {
	activityDropdownOptions,
	DATE_ENTITY,
} from 'features/HorizonScanning/HorizonScanConstants';

import styles from './UpdatesTable.module.scss';

interface IActivityFilterProps {
	openOverride?: boolean;
}
const ActivityFilter = (props: IActivityFilterProps) => {
	const { openOverride } = props;
	const { MODIFIED_DATE } = DATE_ENTITY;
	const { ACTIVITY, DATE_RANGE, CLEAR_ALL } = ACTIVITY_TYPE;

	const dispatch = useDispatch();
	const { clearAll } = styles;
	const [selectedActivity, setSelectedActivity] = useState<string>('');
	const [openDataRangeModel, setOpenDataRangeModel] = useState(false);
	const loggedInUser = useSelector(
		(state: RootState) => state.common.loggedInUser,
	);
	const showAssignedToMeRedux = useSelector(
		(state: RootState) => state.horizonScan.showAssignedToMe,
	);
	const horizonSelectedAppliedfilterKeys = useSelector(
		(state: RootState) => state.horizonScan.horizonSelectedAppliedfilterKeys,
	);
	const setDateRangeModel = (dateRange: string) => {
		setSelectedActivity(dateRange);
	};

	const handleActivityChange = (event: any) => {
		const selectedValue = event.target.value;
		if (selectedValue === CLEAR_ALL) {
			setSelectedActivity('');
			const removeKey = horizonSelectedAppliedfilterKeys.filter(
				(filter: { type: string }) => filter.type !== MODIFIED_DATE,
			);

			const updatedFilterdata = [...removeKey];
			dispatch(setHorizonSelectedAppliedFilterList(updatedFilterdata));
			const filteredArr = filterDataHandler(
				updatedFilterdata,
				showAssignedToMeRedux,
				loggedInUser,
			);
			dispatch(setHorizonFilter(filteredArr));
			return;
		}
		if (selectedValue === DATE_RANGE) {
			setOpenDataRangeModel(true);
			return;
		}
		setSelectedActivity(selectedValue);
	};
	const handleClose = (type?: string) => {
		if (type === 'close') {
			setSelectedActivity('');
		}
		setOpenDataRangeModel(false);
	};
	useEffect(() => {
		if (selectedActivity) {
			const activityFilter = {
				checked: false,
				label: convertDateforApi(selectedActivity),
				type: MODIFIED_DATE,
				value: convertDateforApi(selectedActivity),
			};
			const filteredData = horizonSelectedAppliedfilterKeys.filter(
				(filter: { type: string }) => filter.type !== MODIFIED_DATE,
			);
			const updatedFilteredData = [...filteredData, activityFilter];
			dispatch(setHorizonSelectedAppliedFilterList(updatedFilteredData));
			const filteredArr = filterDataHandler(
				updatedFilteredData,
				showAssignedToMeRedux,
				loggedInUser,
			);
			dispatch(setHorizonFilter(filteredArr));
		}
	}, [selectedActivity]);
	return (
		<div
			style={{ display: 'flex' }}
			className={`activity-container ${!selectedActivity && 'no-value'}`}
		>
			<FormControl variant="filled" size="small" sx={{ m: 1, minWidth: 120 }}>
				<InputLabel
					sx={{ top: `${!selectedActivity ? '-5px' : '0'}` }}
					id="activity-label"
				>
					{ACTIVITY}
				</InputLabel>
				<Select
					inputProps={{
						'data-testid': 'activity-options',
					}}
					open={openOverride}
					className={styles['select-activity']}
					label={ACTIVITY}
					name={ACTIVITY}
					id="activityDropdown"
					value={selectedActivity}
					renderValue={(value: string) => `${value}`}
					onChange={handleActivityChange}
					IconComponent={ExpandMoreRoundedIcon}
					type="listbox"
				>
					{activityDropdownOptions?.map((option) => (
						<MenuItem
							data-testid={option.label}
							sx={
								option.value === CLEAR_ALL
									? {
											color: clearAll,
											textDecoration: 'underline',
									  }
									: {}
							}
							className={option.value === CLEAR_ALL ? 'clear-all' : ''}
							value={option.value}
							key={option.value}
						>
							{option.label}
						</MenuItem>
					))}
				</Select>
			</FormControl>
			{openDataRangeModel && (
				<DateRangeModel
					openModal={openDataRangeModel}
					handleClose={handleClose}
					handleSubmit={setDateRangeModel}
				/>
			)}
		</div>
	);
};

export default ActivityFilter;
